import { HttpClient } from "../HttpClient";

export const UpdateClaimSubmissionStatus = async (id, status) => {
  try {
    const formData = new FormData();
    formData.append("Status", status);

    const { data } = await HttpClient.put(`api/ClipSubmissions/${id}`, formData);
    return data;
  } catch (err) {
    console.error("Error updating claim submission status:", err);
    return null;
  }
};
